import Snackbar from './Snackbar';
import enhancer from './Snackbar.enhancer';

export default enhancer(Snackbar);
